<div>
  <ValidatedTextField class="field" id="{{id}}" maxlength="10" [label]="label" [text]="dateToString(date)"
    [validationLabel]="validationLabel" [disabled]="disabled" (blur)="updateDate($event)"
    helperText="Format as MM/DD/YYYY" [validators]="validators"></ValidatedTextField>
</div>